module.exports = __webpack_public_path__ + "static/img/21-广州金领技工.aa302395.png";